import "./LegalPages.module.css";
import Header from "@/reusable_sections/Header";
import Protocol from "./sections/Protocol";
import Terms from "./sections/Terms";
import Cookieconsentbanner from "./sections/Cookieconsentbanner";
import Footer from "@/reusable_sections/Footer";
export default function LegalPagesPage() {
  return <div>
      <Header />
      <Protocol />
      <Terms />
      <Cookieconsentbanner />
      <Footer />
    </div>;
}